export default __webpack_public_path__ + "static/media/user-man.ea2518fa.svg";